<template>
  <div>
    <div
      class="sourcing"
      :class="{ scrollFixed: isFixed }"
      :style="{ top: calcFixedTop }"
    >
      <div class="sourcing-main">
        <div class="ship">
          <div class="ship-title">
            <SvgIcon
              :svg="shippingIcon"
              color="#232323"
            />
            <span>Shipping to</span>
          </div>
          <Popover
            @show="isArrowRotate = true"
            @hide="isArrowRotate = false"
            :width="240"
            :offset="4"
            placement="bottom" 
            trigger="click">
            <template #reference>
              <div class="ship-main">
                <img
                  :src="shipCountry?.countryUrl"
                  alt=""
                  class="ship-country-img"
                >
                <span class="ship-main-title">{{ shipCountry?.countryName }}</span>
                <Icon 
                  style="margin-left: 4px;"
                  class="icon-arrow-down" 
                  :class="{ 'rotate-180': isArrowRotate }"
                  name="arrow-down-l-2" 
                />
              </div>
            </template>
            <ShipTo 
              :currentCountry="shipCountry"
              @update="getShipPackage"/>
          </Popover>
        </div>
        <div class="line" />
        <div class="fulfillment">
          Fulfillment Supplier
        </div>
        <div class="bd">
          <img
            src="@/assets/images/bd-logo.svg"
            alt=""
          >
          <div class="bd-partner">
            1688 Official Partner
          </div>
        </div>
        <div class="est-info">
          <div class="est-info_total-cost">Est.Total Cost</div>
          <div class="est-info_total-items">
            <div>Total Items</div>
            <div v-if="shipPackage.itemAmount">
              {{ currencyData?.targetCurrency?.slice(0, 2) }} {{ currencyData.targetUnit }}{{ shipPackage.itemAmount }}
            </div>
            <div v-else>--</div>
          </div>
          <div class="est-info_shipping">
            <div class="est-info_shipping_left">
              Est.Shipping
              <Tooltip :offset="4">
                <template #content>
                  <div v-if="hasMapping" style="width: 200px;">
                    When you buy different items, Bestdealer will intelligently combine these items for shipment, and the shipping cost may be lower.
                  </div>
                  <div v-else style="width: 200px;">
                    The length, width, height and weight of the items currently provided by the merchant have not been inspected by Bestdealer's warehouse and may have certain deviations.
                  </div>
                </template>
                <Icon name="icon-help-tip-l"></Icon>
              </Tooltip>
            </div>
            <div v-if="Number(shipPackage.shipAmount) === 0" class="free-shipping">Free Shipping</div>
            <div v-else>
              <template v-if="shipPackage.shipAmount">
                {{ currencyData?.targetCurrency?.slice(0, 2) }} {{ currencyData.targetUnit }}{{ shipPackage.shipAmount }}
              </template>
              <template v-else>--</template>
            </div>
          </div>
          <div class="est-info_total-price">
            <div class="price">
              <IntlCurrency
                :count="shipPackage.totalAmount || '0.00'"
                :size="24"
                :currency="currencyData?.targetCurrency?.slice(0, 2)"
              />
            </div>
            <div class="total">
              <span class="total_quantity">{{ skuQuntity }}</span>items
              <span class="total_quantity">{{ estimatedQuntity }}</span>pcs
            </div>
          </div>
        </div>
        <div 
          @click="addToCart" 
          class="add-to-cart">
          <Icon name="icon-cart-l" style="transform: scale(1.2);"></Icon>
          Add to Cart
        </div>
        <div v-if="showErrorTip" class="error-tips">Quantity cannot be empty. Please select a quantity first.</div>
        <div
          v-if="showTips"
          class="sourcing-tip"
        >
          <img
            class="sourcing-tip-icon"
            src="@/assets/images/warning.svg"
            alt=""
          >
          <div class="text">
            Your request will be processed within 1 business day. Note: Some items may face customs restrictions in your country. We're verifying clearance status. While waiting, consult our category experts free of charge.
          </div>
          <div
            @click.stop="skipThirdPage"
            class="contact-us"
          >
            Free Expert Consultation Now!
          </div>
        </div>

        <div class="sourcing-now-info">
          <img
            src="@/assets/offer/bank-card.svg"
            alt=""
            class="sourcing-now-info-icon"
          >
          <div class="sourcing-now-info-text">
            <div class="sourcing-now-info-text-title">
              Payment methods:
            </div>
            <div class="with-support">
              with
              <img src="@/assets/illus/illus-paypal.svg" alt="">
              or
              <span>Bank Transfer</span>
            </div>
          </div>
        </div>

        <div class="line"></div>
        <div class="rating">
          <img
            src="@/assets/offer/gift.svg"
            alt=""
            class="rating-gift"
          >
          <div class="rating-title">
            Know Your Supplier
            <Popover 
              :offset="6"
              :width="180"
              placement="bottom" 
              trigger="hover">
              <template #reference>
                <SvgIcon :svg="iconWarning" :width="14"></SvgIcon>
              </template>
              <Rating :offer-data="offerData"/>
            </Popover>
          </div>
        </div>
        <div class="credit-title">Direct-from-factory for every item</div>
        <div class="credit-rating">
          <img src="@/assets/illus/illus-supplier-trusted.svg" alt="">
          <div class="text">Credit Rating</div>
          <div class="star-rating">
            <img src="@/assets/colorIcon/star.svg" alt="">
            <div class="label">
              {{ Number(offerData?.sellerDataInfo?.compositeServiceScore).toFixed(1) }} 
              <span>/ 5</span>
            </div>
          </div>
        </div>
      </div>
      <div class="buyee-guarantee">
        <img
          class="top-img"
          src="@/assets/offer/buyer-guarantee.svg"
          alt=""
        >
        <div class="item">
          <img
            src="@/assets/offer/buyer-guarantee-logo1.svg"
            alt=""
          >
          <div class="right-info">
            <div class="header">
              Secure Payments
            </div>
            <div class="content">
              Every payment you make on Bestdealer is secured with strict SSL encryption and PCI DSS data protection protocols.
            </div>
          </div>
        </div>
        <div class="line" />
        <div class="item">
          <img
            src="@/assets/offer/buyer-guarantee-logo2.svg"
            alt=""
          >
          <div class="right-info">
            <div class="header">
              Standard Refund Policy
            </div>
            <div class="content">
              If your order hasn’t shipped, is missing, or has product issues, Please contact us proactively to request a refund.
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddressInfoDialog
      v-if="showAddressInfoDialog"
      :address-type="addressType"
      :current-country="currentCountry"
      :handle-close="handleCloseAddressInfoDialog"
      @click="stopClick"
      :show-address-info-dialog-data="showAddressInfoDialogData"
      @save-address="saveAddress"
    />

    <ExceedQuantityDialog
      v-if="exceedOrderQuantityDialog"
      @close="exceedOrderQuantityDialog = false"
      :quantity="offerData?.minOrderQuantity"
    />
  </div>
</template>

<script setup>
import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  onUnmounted,
  ref,
  watch
} from 'vue'
import { useStore } from 'vuex'
import ShipTo from './components/ShipTo/index.vue'
import Rating from './components/Rating/index.vue'
import AddressInfoDialog from './components/AddressInfoDialog/index.vue'
import { fetchData } from '../../../utils/fetch'
import {
  bankersRound,
  buriedPointUtil,
  gaAnalytics,
  metaPixelTrack
} from '../../../utils/utils'
import { usePlugin } from '@/hooks/usePlugin'
import { useUserStore } from '@/pinia/user'
import { useLoginModal } from '@/components/Login'
import { useIntercom } from '@/hooks/useIntercom'
import { useRoute } from 'vue-router'
import ExceedQuantityDialog from '@/components/ExceedQuantityDialog/index.vue'
import shippingIcon from '@/assets/offer/shipto-icon.svg?raw'
import Popover from '@/components/Popover/index.vue'
import Icon from '@/components/Icon/Icon.vue'
import Tooltip from '@/components/Tooltip/index.vue'
import storage from '@/utils/storage' 
import iconWarning from '@/assets/images/icon-warning-outline.svg?raw'

const { $toast } = usePlugin()
const intercom = useIntercom()

const props = defineProps({
  showTips: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(['addCartSuccess', 'soucingSuccess'])

const store = useStore()
const route = useRoute()

const { open: openLoginModal } = useLoginModal()

const offerData = computed(() => store.state.offerDetail)
const supplierFee = computed(() => store.state.supplierFee)
const currencyData = computed(() => store.state.currencyData)

const user = useUserStore()

const showAddressInfoDialog = ref(false)
const showAddressInfoDialogData = ref({})

const isFixed = ref(false)
const headerHeight = ref(221)

const addressType = ref(null)

const isArrowRotate = ref(false) // 是否旋转箭头

// 超出起订量弹窗
const exceedOrderQuantityDialog = ref(false)

const mergedArray = computed(() => store.state.mergedArray)

const countryList = computed(() => store.state.countryInfo)

const currentCountry = computed(() => store.state.currentCountry)

const cartCount = computed(() => store.state.cart.cartCount)

const ceilingVisible = computed(() => store.state.ceilingVisible)

const shipInfo = computed(() => store.state.shipInfo)

const shipCountry = computed(() => {
  const country = shipInfo.value.country
  if (country) return country

  // 默认显示美国
  const usCountry = countryList.value.find(item => item.countryCode === 'US')
  return usCountry
})

const estimatedQuntity = computed(() => {
  if (mergedArray.value == null) return 0
  return mergedArray.value.reduce((pre, cur) => {
    return pre + cur.quantity
  }, 0)
})

// sku的选择数量
const skuQuntity = computed(() => {
  const skuAttributes = mergedArray.value.map(item => {
    const skuAttributes = item.skuAttributes
    return skuAttributes[0].value
  })

  const uniqueSkuAttributes = [...new Set(skuAttributes)]
  return uniqueSkuAttributes.length
})

const calcFixedTop = computed(() => {
  if (ceilingVisible.value) {
    return '132px'
  } else {
    if (isFixed.value) {
      return '24px'
    } else {
      return 'auto'
    }
  }
})

watch(estimatedQuntity, (value) => {
  if (value > 0) {
    showErrorTip.value = false
  }
})

// 获取预估费用
watch(mergedArray, (value) => {
  if (value.length > 0) {
    getShipPackage()
  } else {
    shipPackage.value = {}
  }
})

let fetchId = 0 // 竞态处理
const shipPackage = ref({})
const getShipPackage = async () => {
  if (!mergedArray.value.length) return
  
  fetchId += 1
  const currentId = fetchId

  const offerId = route.params.id
  const params = {
    address: {
      countryCode: shipCountry.value.countryCode,
      zip: shipInfo.value.postCode,
    },
    details: mergedArray.value.map(item => ({
      offerId,
      skuId: item.skuId,
      quantity: item.quantity,
    })),
    currency: currencyData.value.targetCurrency,
  }

  fetchData('/appb/b2b/fee/calcProductFulfillmentFee', {
    method: 'post',
    body: JSON.stringify(params)
  }).then(res => {
    if (currentId === fetchId) {
      const details = res.data.details
      shipPackage.value = details[0].shipPackage
    }
  })
}

const handleScroll = () => {
  if (window.scrollY > headerHeight.value) {
    isFixed.value = true
  } else {
    isFixed.value = false
  }
}

const showErrorTip = ref(false)
const addToCart = async () => {
  if (!user.userInfo.tk) {
    openLoginModal()
    return
  }

  gaAnalytics('P_Add_to_Cart', 'P_Add_to_Cart')
  gaAnalytics('p_add_to_cart_click', 'p_add_to_cart_click')
  buriedPointUtil({ eventId: 'PPD202' })

  showErrorTip.value = false
  if (estimatedQuntity.value === 0) {
    $toast('Quantity cannot be empty.', { type: 'error' })
    showErrorTip.value = true
    return
  } 
  
  if (offerData.value.minOrderQuantity > estimatedQuntity.value) {
    $toast('The minimum order quantity for the product has not been reached. Please continue to add products.', {
      type: 'error'
    })
    return
  }

  /**
   * Meta Pixel 埋点：点击加入购物车
   */
  metaPixelTrack('PAC201', 'AddToCart', {
    content_ids: [offerData.value.offerId],
    content_type: 'product',
    currency: '$',
    value: 2
  })

  const addressForm = localStorage.getItem('addressForm')
    ? JSON.parse(localStorage.getItem('addressForm'))
    : {}

  if (Object.keys(addressForm).length === 0) {
    addressType.value = 2
    showAddressInfoDialog.value = true
    return
  }

  const { code, msg } = await fetchData('/appb/b2b/cart/cartAddV2', {
    method: 'post',
    body: JSON.stringify({
      currency: currencyData.value.targetCurrency,
      currencyUnit: currencyData.value.targetUnit,
      details: mergedArray.value
    })
  })
  if (code === 200) {
    gaAnalytics('p_add_to_cart_success', 'p_add_to_cart_success')
    buriedPointUtil({ eventId: 'PPD601' })
    $toast('Added successfully', { type: 'success' })
    await getCartCount()
    store.commit('setMergedArray', [])
    emits('addCartSuccess')
  } else if ([5216, 5217].includes(code)) {
    $toast(msg, { type: 'error' })
  } else if (code === 200001) {
    $toast('Please fill delivery address.')
    localStorage.removeItem('addressForm')
    showAddressInfoDialog.value = true
  } else if (code === 100001) {
    // 显示超出起订量弹窗
    exceedOrderQuantityDialog.value = true
  } else {
    $toast('Add to cart failed', { type: 'error' })
  }
}

const getCartCount = async () => {
  const { code, data } = await fetchData('/appb/b2b/cart/cartCount')
  if (code === 200) {
    store.commit('cart/SET_CART_COUNT', data)
  }
}

watch(currencyData, (newData) => {
  if (newData) {
    currencyData.value = newData
  }
})

watch(supplierFee, (newData) => {
  if (newData) {
    supplierFee.value = newData
  }
})

const stopClick = (event) => {
  event.stopPropagation()
}

const handleCloseAddressInfoDialog = () => {
  showAddressInfoDialog.value = false
}

const skipThirdPage = async () => {
  intercom.showNewMessage()
}

const saveAddress = () => {
  $toast('Address saved successfully', { type: 'success' })
  showAddressInfoDialog.value = false
}

const hasMapping = ref(false)
const queryMapping = async () => {
  const { data } = await fetchData('/appb/alibaba-common/queryMaintenance', {
    method: 'post',
    body: JSON.stringify([route.params.id])
  })
  hasMapping.value = data[0].hasMapping
}

onMounted(async () => {
  window.addEventListener('scroll', handleScroll)
  nextTick(() => {
    const headerPc = document.querySelector('.header-pc')
    const height = headerPc ? headerPc.offsetHeight : 221
    headerHeight.value = height
  })
  queryMapping()
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style lang="less">
@import "./index.less";
</style>
